import { Row, Col, Typography, Space } from 'antd';

import { InfoWithLabel } from 'common/components';

import { MEASUREMENT_UNIT } from '../../constants';

import {
  renderName,
  renderDescription,
  getNameAndItalicizeNameSupplement,
} from 'pages/product-full-view/components/product-media-area/supplement-label/utils';

const { Text } = Typography;

const renderViewMode = (props) => {
  const { item, fieldName } = props;

  const convertUom = (unit) => {
    return MEASUREMENT_UNIT[unit?.toLowerCase()] || unit;
  };

  const renderQuantity = () => {
    const convertedUom = item.quantityUom ? convertUom(item.quantityUom) : '';

    const quantity =
      item.quantity === null || item.quantity === undefined
        ? ''
        : `${Math.round(item.quantity * 100) / 100}${convertedUom}`;

    return [quantity].filter(Boolean).join(' ');
  };

  const renderDailyValue = () => {
    return `${
      item.dailyValue !== undefined && item.dailyValue !== null
        ? item.dailyValue + '%'
        : ''
    }${item.dailySymbol ? item.dailySymbol : ''}`;
  };

  const { name, italicName } = getNameAndItalicizeNameSupplement(
    item,
    fieldName
  );
  const description = renderDescription(item?.quantityDescription, false);

  return (
    <>
      <Row gutter={8}>
        <Col span={24}>
          <Text
            style={{ fontWeight: 700 }}
            ellipsis={{
              tooltip: `${renderName(name, false)} ${renderDescription(
                item?.descriptor,
                false
              )}`,
            }}
          >
            {renderName(name, italicName)}
            {renderDescription(item?.descriptor, item?.italicDescriptor)}
          </Text>
        </Col>
        <Col span={24}>
          <Row>
            <Col span={12}>
              <Space>
                <Text>{item.quantityPrecision}</Text>
                <Text strong>{renderQuantity()}</Text>
              </Space>
              {description && <Text>{description}</Text>}
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <Space>
                <Text>{item.dailyValuePrecision}</Text>
                <Text strong>{renderDailyValue()}</Text>
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>
      {item?.ingredientsPartOf ? (
        <InfoWithLabel
          showTooltip
          label='Part Of'
          info={item?.ingredientsPartOf}
          labelColProps={{ span: 4 }}
          infoColProps={{ span: 20 }}
        />
      ) : null}
    </>
  );
};

export default renderViewMode;
